/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  SearchVariantsQueryResponse,
  SearchVariantsQueryParams,
} from '../types/SearchVariants'

function getSearchVariantsUrl() {
  const res = { method: 'GET', url: `/api/v1/common/search/variants/` as const }
  return res
}

/**
 * @description Handle GET request for search.
 * This is the main entry point that orchestrates the search process.
 * @summary Search the tenant's product variants
 * {@link /api/v1/common/search/variants/}
 */
export async function searchVariants(
  params: SearchVariantsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    SearchVariantsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getSearchVariantsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
